import React, { Component } from "react";
import "./NonPoItems.css";
import SideNav from "../sidenav/Sidenav.js";
import { CrfContext } from "../../CrfContext";
import { Redirect } from "react-router-dom";
import { getData, localValidation } from "./actions";
import { Transition, animated } from "react-spring/renderprops";

import NonPoItemView from "./NonPoItemView";

import axios from "axios";
import NonPoModal from "./NonPoModal";

export class NonPoItems extends Component {
  state = {
    progress: 0,
    releasingCenter: "BDO Examiner",
    isLoading: false,
    hasApprovedDept: false,
    userDeptList: [],
    userRole: "",

    showBanner: true,
    showForm: false,
    showPage1: false,
    showPage2: false,

    vendor: "",
    vendorError: false,
    vendorErr: 1,
    dueDate: "",
    receivingDate: "",
    termDays: "",
    particulars: "",
    particularsError: false,
    particularsErr: 1,
    requestingDepartment: "",
    poNumber: 1,
    poNumberError: false,
    poNumberErr: 1,
    project: "",
    projectError: false,
    projectErr: 1,
    subProject: "",
    file: null,
    fileError: false,
    fileErr: 1,
    budgetLineItem: "",

    projectClass: [
      {
        glCategory: "",
        glAccount: "",
        budgetLineItem: "",
        description1: "",
        description2: "",
        itemNumber: "",
        grossPricePerItem: 0,
        netPricePerItem: 0,
        quantity: 1,
        costType: "1OV",
        vatType: "None IVAT-X1",
        vatTypeValue: 1,
        wTax: 0,
        wTaxType: "X1",
        wTaxRate: "0",
        wTaxTypeValue: 0,
        wTaxTypeString: "",
        unitPrice: 0,
        subNetPrice: 0,
        projectClass: "",
        subTotalGrossPrice: 0.0,
        subTotalNetPrice: 0.0,
        classDepartment: "",
      },
    ],
    requestingGrossPrice: 0.0,
    requestingAmount: 0.0,
    glCategory: "",
    projectCode: "",
    vendorLists: [],
    departmentLists: [],
    projectLists: [],
    projectCode: "",
    accountTypes: [],
    itemNoList: [],

    redirect: false,
    crfId: "",

    vendorListEmpty: false,
    updateForm: false,
    advancesProjectClass: [],

    subNetList: [],

    vatTypeSelector: "",
    vatTypeSelected: "",

    wTaxRates: [],

    vendorLists: [],
    projectLists: [],

    error: 0,

    removal: false,
    target: null,
    addProjectClass: false,
  };

  formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = "0" + month;
    }
    if (day.length < 2) {
      day = "0" + day;
    }
    return [year, month, day].join("-");
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        showForm: true,
      });
    }, 500);

    // ===================================================================
    // GET VENDOR LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/vendors`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        // document.getElementById('main').style.display = 'block'
        //  
        this.setState({
          vendorLists: response.data.data,
        });
        //  
      })
      .catch((error) => {
          
      });

    //================================================================================

    // GET PROJECT LIST
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/projects`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        //  
        this.setState({
          projectLists: response.data.data,
        });
      })
      .catch((error) => {
          
      });
    // =========================================================

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        //  
        this.setState({
          userDeptList: response.data.data.departments,
          userRole: response.data.data.roles[0],
        });
        let hasApproved = false;
        for (let i = 0; i < response.data.data.departments.length; i++) {
          //  
          if (response.data.data.departments[i].isApproved === true) {
            hasApproved = true;
          }

          if (response.data.data.roles[0] !== "Requestor") {
            if (response.data.data.roles[0] !== "Requestor / Exec. Secretary")
              if (response.data.data.roles[0] !== "Treasury")
                this.setState({
                  redirect: true,
                  crfId: "/RequestSelection",
                  requestor: response.data.data,
                });
          }
        }

        this.setState({
          // userRole: response.data.data.roles[0],
          // userName: response.data.data.firstName
          //  + " " + response.data.data.lastName,
          // requestingDepartment: response.data.data.department.centerName,
          // userId: response.data.data._id
        });
      })
      .catch((error) => {
          
      });
  }

  checkStateValue = (e) => {
    e.preventDefault();
    //  
  };

  // END OF COMPONENT DID MOUNT

  handleChangeRequestField = (e) => {
    e.preventDefault();

    if (e.target.name === "vendor") {
        
      this.setState({ vendorError: true });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/vendors/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          //  
          this.setState({
            vatTypeSelector: response.data.data.vatType,
          });
          // ==================================================================================
          // VENDOR BP CODE WILL GET THE WTAX

          axios({
            method: "GET",
            url: `${process.env.REACT_APP_API_KEY}/api/withHoldingTax/wTaxCode/${response.data.data.bpCode}`,
            headers: {
              "Api-Key":
                "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
              Authorization: `Bearer ${localStorage.token}`,
            },
          })
            .then((response) => {
              //  
              let newArray = response.data.data;
              const none = {
                wTaxCode: "X1",
                wTaxName: "",
                wTaxDisplayName: "None ",
                rate: "0",
              };
              newArray.push(none);
              this.setState({
                wTaxRates: newArray,
              });
              //  
            })
            .catch((error) => {
                
            });

          // ==================================================================================
        })
        .catch((error) => {
            
        });

      if (
        !this.state.vendorLists.includes(
          document.getElementById(`${e.target.id}`).value
        )
      ) {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText =
          "Invalid Input";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText =
          " " + "(Please input a valid data included in the list)";
        this.setState({ vendorErr: 1 });
      } else {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ vendorErr: 0 });
      }
    }

    if (e.target.name === "receivingDate") {
      this.setState({ receivingDate: e.target.value });
      if (this.state.termDays) {
        const date = new Date(this.state.receivingDate);
        date.setDate(date.getDate() + parseInt(this.state.termDays));
        this.setState({
          dueDate: this.formatDate(date),
        });
      }
    }
    if (e.target.name === "termDays") {
      if (e.target.value < 0) {
        alert("Enter positive numbers only!");
      } else {
        this.setState({ termDays: e.target.value });
        if (this.state.receivingDate) {
          const date = new Date(this.state.receivingDate);
          date.setDate(date.getDate() + parseInt(this.state.termDays));
          this.setState({
            dueDate: this.formatDate(date),
          });
        }
      }
    }

    if (e.target.name === "particulars") {
      this.setState({ particularsError: true });
      if (e.target.value === "") {
        this.setState({ particularsErr: 1 });
      } else {
        this.setState({ particularsErr: 0 });
      }
    }

    if (e.target.name === "requestingDepartment") {
      const copyOfProjectClass = [...this.state.projectClass];
      const projectObj = { ...copyOfProjectClass[0] };
      projectObj.classDepartment = e.target.value;
      copyOfProjectClass[0] = projectObj;
      this.setState({ projectClass: copyOfProjectClass });
    }

    //__________________TRIGGERS THE LOAD OF BUDGET LINE ITEM___________________//
    if (e.target.name === "project") {
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.setState(() => (this.state.projectClass[i].glCategory = ""));
      }
      // ================================================================================================
      this.setState({ projectError: false, projectErr: 0 });

      if (e.target.value === "") {
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[0].innerText = "";
        document.getElementById(
          `${e.target.id}`
        ).nextElementSibling.nextElementSibling.children[1].innerText = "";
        this.setState({ projectErr: 1 });
      }

      // =======================================================
    }

    if (e.target.name === "file" && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split(".");
      let fileExtension = fileName[fileName.length - 1];
      this.setState({ fileError: true });
      if (fileExtension !== "pdf") {
        this.setState({ fileErr: true });
      } else {
        this.setState({ fileErr: 0 });
      }
    }

    if (e.target.name === "file" && e.target.files.length === 0) {
      this.setState({ fileErr: 1 });
    }

    if (e.target.name === "project") {
      this.setState({
        accountTypes: [],
      });
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_KEY}/api/projects/${e.target.value}`,
        headers: {
          "Api-Key":
            "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
        .then((response) => {
          //  
          this.setState({
            projectCode: response.data.data.projectCode,
          });
          //  
          if (this.state.requestingDepartment) {
            const params = {
              projectCode: response.data.data.projectCode,
              department: this.state.requestingDepartment,
            };
            axios({
              method: "POST",
              url: `${process.env.REACT_APP_API_KEY}/api/budgetLineItem/dropdown`,
              headers: {
                "Api-Key":
                  "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
                Authorization: `Bearer ${localStorage.token}`,
              },
              data: params,
            })
              .then((response) => {
                //  
                let budgetLineItem = response.data.data;
                this.setState({
                  accountTypes: budgetLineItem,
                });
              })
              .catch((error) => {
                  
                this.setState({
                  accountTypes: [],
                });
              });
          }
        })
        .catch((error) => {
            
        });
    }

    if (e.target.name === "file" && e.target.files.length !== 0) {
      let fileName = e.target.files[0].name.split(".");
      let fileExtension = fileName[fileName.length - 1];
      fileExtension !== "pdf"
        ? (document.getElementById("documentEmptyError").innerText =
            "(Please upload a valid file(pdf).)")
        : (document.getElementById("documentEmptyError").innerText = "");
    }

    let file = null;
    if (e.target.name === "file") {
      //  
      file = e.target.files[0];
      //  
      this.setState({
        [e.target.name]: e.target.files[0],
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    //  

    this.setState({
      error:
        this.state.vendorErr +
        this.state.particularsErr +
        this.state.projectErr +
        this.state.fileErr,
    });
    //  
  };

  handleProjectInputFunction = (e) => {
    e.preventDefault();
    let glCategoryClass = document.getElementsByClassName("glCategoryClass");

    for (let i = 0; i < glCategoryClass.length; i++) {
      glCategoryClass[i].value = "";
    }
  };

  onBlurNumber = (e, index, key) => {
    const projectClass = [...this.state.projectClass];
    const obj = { ...projectClass[index] };
    if (e.target.value === "") {
      obj[key] = 0;
      projectClass[index] = obj;
      this.setState({
        projectClass,
      });
      return;
    }
  };

  handleWTaxRate = async (wTaxType) => {
    try {
      const { data } = await getData(
        `/api/withHoldingTax/wTaxRate/${wTaxType}`
      );
      return data.Rate;
    } catch (err) {
      return "0";
    }
  };
  projectClassComputation = async (
    qty,
    grossPrice,
    vatType,
    wTaxType,
    projectClass,
    index,
    key
  ) => {
    const data = {
      rate: projectClass[index].wTaxRate,
    };
    if (key === "wTaxType") {
      data.rate = await this.handleWTaxRate(wTaxType);
    }
    const subTotalGrossPrice =
      (qty === "" ? 1 : parseInt(qty)) *
      parseFloat(grossPrice === "" ? 0 : grossPrice);
    const unitPrice =
      subTotalGrossPrice / (vatType === "None IVAT-X1" ? 1 : 1.12);
    const netVat = subTotalGrossPrice - unitPrice;
    const netWTax = unitPrice * (data.rate * 0.01);
    const subTotalNetPrice = subTotalGrossPrice - netWTax;

    projectClass[index].grossPricePerItem = grossPrice;
    projectClass[index].vatType = vatType;
    projectClass[index].wTaxType = wTaxType;
    projectClass[index].wTaxRate = data.rate;
    projectClass[index].subTotalGrossPrice = subTotalGrossPrice.toFixed(2);
    projectClass[index].subTotalNetPrice =
      data.rate === "0"
        ? subTotalGrossPrice.toFixed(2)
        : subTotalNetPrice.toFixed(2);

    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;

    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    //  
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  handleChangeProjectClassValue = (e, index, key) => {
    let projectClassCopy = [...this.state.projectClass];
    if (e.target.name === "classDepartment") {
      projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      this.setState({ projectClass: projectClassCopy });
    }
    if (
      e.target.name === "glCategory" ||
      e.target.name === "glAccount" ||
      e.target.name === "projectClass" ||
      e.target.name === "itemCode"
    ) {
      if (e.target.name === "glCategory") {
        const json = JSON.parse(e.target.value);
        projectClassCopy[parseInt(e.target.id)].glCategory =
          json.budgetLineItem;
      } else {
        projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value;
      }
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "description1" || key === "description2") {
      projectClassCopy[index][key] = e.target.value.trimLeft();
      this.setState({ projectClass: projectClassCopy });
    }
    if (key === "itemCode") {
      projectClassCopy[index][key] = e.target.value.trimRight();
      this.setState({ projectClass: projectClassCopy });
    }

    if (e.target.name === "grossPricePerItem") {
      const grossPrice = e.target.value.split(".");
      if (grossPrice[0].length <= 12) {
        // projectClassCopy[parseInt(e.target.id)][e.target.name] = e.target.value
        // this.setState({projectClass: projectClassCopy})
        this.projectClassComputation(
          1,
          e.target.value,
          this.state.projectClass[index].vatType,
          this.state.projectClass[index].wTaxType,
          projectClassCopy,
          index,
          "grossPricePerItem"
        );
      }
    }
    if (e.target.name === "vatType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        e.target.value,
        this.state.projectClass[index].wTaxType,
        projectClassCopy,
        index,
        "vatType"
      );
    }

    if (e.target.name === "wTaxType") {
      this.projectClassComputation(
        1,
        this.state.projectClass[index].grossPricePerItem,
        this.state.projectClass[index].vatType,
        e.target.value,
        projectClassCopy,
        index,
        "wTaxType"
      );
    }

    // EXTRACT GL ACCOUNT NAME

    // CHANGE GL NAME LISTS

    if (e.target.name === "glCategory") {
      const value = JSON.parse(e.target.value);
      projectClassCopy[
        parseInt(e.target.id)
      ].glAccount = `${value.accountCode} ${value.accountName}`;
      projectClassCopy[parseInt(e.target.id)].budgetLineItem =
        value.budgetLineItem;
      this.setState({
        projectClass: projectClassCopy,
        budgetLineItem: value.budgetLineItem,
      });
    }
  };

  addProjectClass = (e) => {
    e.preventDefault();
    this.setState({
      addedProjectClass: true,
      projectClass: [
        ...this.state.projectClass,
        {
          glCategory: "",
          glAccount: "",
          description1: "",
          description2: "",
          itemNumber: "",
          grossPricePerItem: 0,
          netPricePerItem: 0,
          quantity: 1,
          costType: "1OV",
          vatType: "None IVAT-X1",
          vatTypeValue: 1,
          wTax: 0,
          wTaxType: "X1",
          wTaxRate: "0",
          wTaxTypeValue: 0,
          wTaxTypeString: "",
          unitPrice: 0,
          subNetPrice: 0,
          projectClass: "",
          subTotalGrossPrice: 0.0,
          subTotalNetPrice: 0.0,
          classDepartment: this.state.requestingDepartment, //this.state.userDeptList[0]?.centerName
        },
      ],
    });
    // this.state.projectClass.push(
    //   {
    //           glCategory: "",
    //           glAccount: "",
    //           description1: "",
    //           description2: "",
    //           itemNumber: "",
    //           grossPricePerItem: 0,
    //           netPricePerItem: 0,
    //           quantity: 1,
    //           costType: "1OV",
    //           vatType: "",
    //           vatTypeValue: 1,
    //           wTax: 0,
    //           wTaxType:"X1",
    //           wTaxTypeValue: 0,
    //           wTaxTypeString: "",
    //           unitPrice: 0,
    //           subNetPrice: 0,
    //           projectClass: ""
    //         }
    // )
    //  
  };

  localValidationProjectClasses = async (projectClasses) => {
    let validationRemarks = null;
    let countIndex = 0;
    for (const obj of projectClasses) {
      countIndex = countIndex + 1;
      if (obj.glCategory === "") {
        alert(`Project class ${countIndex}: glCategory is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.description1 === "") {
        alert(`Project class ${countIndex}: description 1 is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.grossPricePerItem === 0) {
        alert(`Project class ${countIndex}: gross price is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.vatType === "") {
        alert(`Project class ${countIndex}: vatType is required`);
        validationRemarks = "Failed";
        break;
      }
      if (obj.wTaxType === "") {
        alert(`Project class ${countIndex}: wTaxType is required`);
        validationRemarks = "Failed";
        break;
      }
    }
    return validationRemarks;
  };

  handleSubmitNonPo = async (e, key) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    let array = this.state.projectClass;

    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateProgress(percentCompleted);
      },
    };

    let formData = new FormData();

    let nonPoForm = {
      receivingDate: this.state.receivingDate,
      termDays: this.state.termDays,
      dueDate: this.state.dueDate,
      department: this.state.requestingDepartment,
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      releasingCenter: this.state.releasingCenter,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Non PO Item",
      status: "For Approval",
    };

    //validate to view loading
    const fieldToValidate = localValidation(nonPoForm);
    if (fieldToValidate !== null) {
      this.setState({ isLoading: false });
      alert(`${fieldToValidate} is required`);
      return "remainOnFirstPage";
    } else {
      const vendor = await getData(`/api/vendors/${nonPoForm.vendor}`);
      const project = await getData(`/api/projects/${nonPoForm.project}`);
      if (vendor.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the vendor is valid");
        return "remainOnFirstPage";
      }
      if (project.data === null) {
        this.setState({ isLoading: false });
        alert("Please make sure that the project is valid");
        return "remainOnFirstPage";
      }
      if (this.state.file === null || this.state.fileErr === 1) {
        this.setState({ isLoading: false });
        alert("Supporting documents is required");
        return "remainOnFirstPage";
      }
      if (key === "fromFirstPage") {
        this.setState({ isLoading: false });
        return;
      }
      const validationProjectClasses = await this.localValidationProjectClasses(
        nonPoForm.projectClasses
      );
      if (validationProjectClasses) {
        this.setState({ isLoading: false });
        return;
      }
      document.getElementById("modalBody").style.display = "block";
    }

    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
      onUploadProgress: config.onUploadProgress,
    })
      .then((response) => {
        this.setState({
          isLoading: false,
          redirect: true,
          crfId: `/CheckRequest/${response.data.Data._id}`,
        });
        document.getElementById("modalBody").style.display = "none";
      })
      .catch((error) => {
        this.setState({ isLoading: false });
          
        // document.getElementById("formHintContainer").style.display = "block";
        // document.getElementById("modalBody").style.display = "none";
        // document.getElementById("errorHint").innerText =
        //   " " +
        //   "Please make sure you filled up the required fields at Project Class" +
        //   " " +
        // (parseInt(error.data.Error.slice(-1)) + 1);
        // document.getElementById("form-validation-error").innerText = "Please fill out the required fields or check if your input is correct"
      });
  };

  handleDraftNonPo = (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    let array = this.state.projectClass;

    const updateProgress = (progressState) => {
      this.setState({ progress: progressState });
    };
    const config = {
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        updateProgress(percentCompleted);
      },
    };

    let formData = new FormData();

    let nonPoForm = {
      requestor: this.state.requestor,
      receivingDate: this.state.receivingDate,
      termDays: this.state.termDays,
      dueDate: this.state.dueDate,
      department: this.state.requestingDepartment,
      vendor: this.state.vendor,
      project: this.state.project,
      projectClasses: this.state.projectClass,
      releasingCenter: this.state.releasingCenter,
      subProject: this.state.subProject,
      particulars: this.state.particulars,
      requestType: "Non PO Item",
      status: "Draft",
      supportingDocuments: this.state.file,
    };

    //validate to view loading
    formData.set("crfForm", JSON.stringify(nonPoForm));
    formData.append("supportingDocuments", this.state.file);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/draft`,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
      onUploadProgress: config.onUploadProgress,
    })
      .then((response) => {
        this.setState({
          isLoading: false,
          redirect: true,
          crfId: `/Draft/${response.data.data.insertedIds[0]}`,
        });
      })
      .catch((error) => {
          
      });
  };

  handleRemoveProjectClass = (e, index) => {
    e.preventDefault();
    const projectClass = [...this.state.projectClass];
    projectClass.splice(index, 1);
    let requestingGrossPrice = 0.0;
    let requestingAmount = 0.0;
    for (let obj of projectClass) {
      requestingGrossPrice =
        parseFloat(obj.subTotalGrossPrice) + parseFloat(requestingGrossPrice);
      requestingAmount =
        parseFloat(obj.subTotalNetPrice) + parseFloat(requestingAmount);
    }
    this.setState({
      projectClass,
      requestingGrossPrice: requestingGrossPrice.toFixed(2),
      requestingAmount: requestingAmount.toFixed(2),
    });
  };

  render() {
    let vatTypeSelections = "";
    if (this.state.vatTypeSelector == "") {
      vatTypeSelections = (
        <>
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      );
    } else if (this.state.vatTypeSelector == "VAT-G") {
      vatTypeSelections = (
        <>
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Goods IVAT-G">Goods IVAT-G</option>
        </>
      );
      // for (let i = 0; i < this.state.projectClass.length; i++) {
      //   this.state.projectClass[i].vatType = "Goods IVAT-G"
      // }
      // //  
    } else if (this.state.vatTypeSelector == "VAT-DS") {
      vatTypeSelections = (
        <>
          {/* <option value="" disabled selected hidden>Please Choose...</option> */}
          <option value="None IVAT-X1">None IVAT-X1</option>
          <option value="Services IVAT-S">Services IVAT-S</option>
        </>
      );
    } else if (this.state.vatTypeSelector == "X1") {
      vatTypeSelections = (
        <>
          <option value="None IVAT-X1">None IVAT-X1</option>
        </>
      );
      for (let i = 0; i < this.state.projectClass.length; i++) {
        this.state.projectClass[i].vatType = "None IVAT-X1";
      }
      // //  
    }

    if (this.state.redirect === true) {
      return <Redirect to={this.state.crfId} />;
    }

    return (
      // <CrfContext.Consumer>
      //   {(context) => (
      <form id="mainPage">
        <NonPoModal progress={this.state.progress} />
        <div id="sidePanel">
          <SideNav />
        </div>
        <div id="mainPanel">
          {/* BANNER */}
          <Transition
            native
            items={this.state.showBanner}
            from={{ opacity: 0, marginTop: -500 }}
            enter={{ opacity: 1, marginTop: 0 }}
            leave={{ opacity: 0, marginTop: -500 }}
            // config={{ duration: 1000 }}
          >
            {(show) =>
              show &&
              ((props) => (
                <animated.div style={props}>
                  <div className="requestFormBanner">
                    <h1>NON PO ITEMS</h1>
                  </div>
                </animated.div>
              ))
            }
          </Transition>
          {/* END OF BANNER */}
          {/* FORM */}
          <div className="formContainer">
            <Transition
              native
              items={this.state.showForm}
              from={{ opacity: 0 }}
              enter={{ opacity: 1 }}
              leave={{ opacity: 0 }}
              config={{ duration: 300 }}
            >
              {(show) =>
                show &&
                ((props) => (
                  <animated.div style={props}>
                    <NonPoItemView
                      // userDepartment = {context.state.userDepartment}
                      // vendorLists = {context.state.vendorLists}
                      // projectLists = {context.state.projectLists}
                      // cocExpenses = {context.state.cocExpenses}
                      // advances = {context.state.advances}
                      // ppeAccounts = {context.state.ppeAccounts}
                      // adminExpenses = {context.state.adminExpenses}
                      // advancesProjectClass = {context.state.advancesProjectClass}
                      releasingCenter={this.state.releasingCenter}
                      dueDate={this.state.dueDate}
                      requestingGrossPrice={this.state.requestingGrossPrice}
                      requestingAmount={this.state.requestingAmount}
                      onBlurNumber={this.onBlurNumber}
                      userDeptList={this.state.userDeptList}
                      isLoading={this.state.isLoading}
                      vendor={this.state.vendor}
                      vendorError={this.state.vendorError}
                      vendorErr={this.state.vendorErr}
                      particulars={this.state.particulars}
                      particularsError={this.state.particularsError}
                      particularsErr={this.state.particularsErr}
                      project={this.state.project}
                      projectError={this.state.projectError}
                      projectErr={this.state.projectErr}
                      file={this.state.file}
                      fileError={this.state.fileError}
                      fileErr={this.state.fileErr}
                      projectClass={this.state.projectClass}
                      accountTypes={this.state.accountTypes}
                      vatTypeSelector={this.state.vatTypeSelector}
                      vatTypeSelections={vatTypeSelections}
                      wTaxRates={this.state.wTaxRates}
                      handleChangeRequestField={this.handleChangeRequestField}
                      handleChangeProjectClassValue={
                        this.handleChangeProjectClassValue
                      }
                      budgetLineItem={this.state.budgetLineItem}
                      addProjectClass={this.addProjectClass}
                      handleSubmitNonPo={this.handleSubmitNonPo}
                      handleDraftNonPo={this.handleDraftNonPo}
                      checkStateValue={this.checkStateValue}
                      vendorLists={this.state.vendorLists}
                      projectLists={this.state.projectLists}
                      handleRemoveProjectClass={this.handleRemoveProjectClass}
                      addedProjectClass={this.state.addedProjectClass}
                    />
                  </animated.div>
                ))
              }
            </Transition>
          </div>
          {/* END OF FORM */}
        </div>
      </form>

      //   )}
      // </CrfContext.Consumer>
    );
  }
}

const dark = {
  color: "black",
};

export default NonPoItems;
